import React, { useState, useEffect } from 'react';
import { ComparisonDetailMembersDataType, DirectMemberComparisonItemPropsType } from '../../types';
import './DirectMemberComparisons.css';
import DirectMemberComparisonItem from './DirectMemberComparisonItem';
import {
    formatMandateForComparison,
    formatMemberActivityForComparison,
    formatMemberNameForComparison,
    formatPartyForComparison,
    formatVotingAttendanceForComparison
} from './formattingFunctions';
import { useTranslation } from 'react-i18next';

const DirectMemberComparisons = ({ firstMember, secondMember }: ComparisonDetailMembersDataType) => {
    const { t } = useTranslation('analyses');
    const [, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const comparisonItems: Array<
        Pick<DirectMemberComparisonItemPropsType, 'description' | 'valueKey' | 'formattingFunc' | 'isLinkToMember'>
    > = [
        {
            description: t('comparison-name'),
            valueKey: 'jmeno',
            formattingFunc: formatMemberNameForComparison,
            isLinkToMember: true
        },
        {
            description: t('comparison-activity'),
            valueKey: 'aktivni_clen',
            formattingFunc: formatMemberActivityForComparison
        },
        {
            description: t('comparison-mandate'),
            valueKey: 'dochazka.mandat',
            formattingFunc: formatMandateForComparison
        },
        {
            description: t('comparison-party'),
            valueKey: 'politicke_strany.0',
            formattingFunc: formatPartyForComparison
        },
        {
            description: t('comparison-voting-attendance'),
            valueKey: 'dochazka.attendance_stat',
            formattingFunc: formatVotingAttendanceForComparison
        }
    ];

    return (
        <div className='members-comparison-summary'>
            {comparisonItems.map((item) => {
                return (
                    <DirectMemberComparisonItem
                        firstMemberData={firstMember}
                        secondMemberData={secondMember}
                        valueKey={item.valueKey}
                        description={item.description}
                        formattingFunc={item.formattingFunc}
                        key={item.description}
                        isLinkToMember={item.isLinkToMember}
                    />
                );
            })}
        </div>
    );
};

export default DirectMemberComparisons;
